export const useInsertBoldTag = () => {
    const insertBoldTag = (page, formData, setFormData, lg) => {
        const textarea = document.querySelector(`${page} .textarea textarea`);
        let text = textarea.value;
        
        let start = textarea.selectionStart;
        let end = textarea.selectionEnd;
        
        if (start === end) {
            return;
        }

        const beforeText = text.substring(0, start);
        const selectedText = text.substring(start, end);
        const afterText = text.substring(end);

        setFormData({
            ...formData,
            [`descrip_${lg}`]: beforeText + `[b]${selectedText}[/b]` + afterText
        });
    };

    return insertBoldTag;
};